"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToothRootMaskValue_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var ToothRootMaskValue_Factory = /** @class */ (function () {
    function ToothRootMaskValue_Factory() {
    }
    ToothRootMaskValue_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            CombinationString: model.CombinationString,
            ToothRootMaskValue1: model.ToothRootMaskValue1,
        };
        return result;
    };
    ToothRootMaskValue_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            CombinationString: model.CombinationString,
            ToothRootMaskValue1: model.ToothRootMaskValue1,
        };
        return result;
    };
    return ToothRootMaskValue_Factory;
}());
exports.ToothRootMaskValue_Factory = ToothRootMaskValue_Factory;
